export default __webpack_public_path__ + "static/media/rolandomedina-2.d7a79a7b.jpg";